import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { OrganisationSettingsService } from '@/api';
import type { EffectiveSettings } from '@/types/organisation';

interface UseEffectiveSettingsOptions {
  childcareId?: string;
}

export function useEffectiveSettings(options: UseEffectiveSettingsOptions = {}) {
  const { orgId, isSignedIn } = useAuth();

  return useQuery({
    queryKey: ['settings', 'effective', orgId, options.childcareId],
    queryFn: async () => {
      const response = await OrganisationSettingsService.getApiV1SettingsEffective(
        options.childcareId
      );
      return response as EffectiveSettings;
    },
    enabled: !!orgId && isSignedIn,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
  });
}